<template lang="pug">
  .wrap
    .main
      .main-inner
        .main-header
          .guide-head
            h2 メール通知設定
            a.guide-head-button(@click="openGuide") 使い方
          p
            | メール通知設定は最大50件まで登録することができます。<br />
            | 保存した通知設定が上限を超えた場合「削除する」にて既存の条件を整理してご利用ください。<br />
            | 登録した検索条件に加えて、【除外企業管理】、【登録企業管理】が【ON】になっている場合は、そのフィルタも適用されます。
        .blankslate(v-if="!index.length")
          h1 メール通知設定が登録されていません。

        JobNotificationSetting(v-for="(v, i) in index", :condition="v", :index="i", :key="v.id")
</template>

<script>
  import { mapGetters } from 'vuex'
  import JobNotificationSetting from './parts/JobNotificationSetting'

  export default {
    components: { JobNotificationSetting },
    async asyncData ({ store }) {
      await store.dispatch('jobNotificationSetting/fetchIndex')
    },
    computed: {
      ...mapGetters({
        index: 'jobNotificationSetting/humanizedIndex',
      }),
    },
    methods: {
      openGuide () {
        window.open('/guide/job_notification_settings', '_blank', 'noreferrer')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/JobNotificationSettings.vue